import { render, staticRenderFns } from "./DeleteConfirmModal.vue?vue&type=template&id=5d0c30fa&"
import script from "./DeleteConfirmModal.vue?vue&type=script&lang=js&"
export * from "./DeleteConfirmModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d0c30fa')) {
      api.createRecord('5d0c30fa', component.options)
    } else {
      api.reload('5d0c30fa', component.options)
    }
    module.hot.accept("./DeleteConfirmModal.vue?vue&type=template&id=5d0c30fa&", function () {
      api.rerender('5d0c30fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/whitelist/components/DeleteConfirmModal.vue"
export default component.exports